import { cn, formatDateExtended } from "@/lib/utils"
import { ContractStatusKey } from "@/hooks/contracts/useContractStatus"
import { useTranslation } from "react-i18next"

const contractsPaymentBadgeStyles = {
  active: "bg-payment-paid text-foreground",
  pending: "bg-payment-notpaid text-foreground",
  pending_manual: "bg-payment-notpaid text-foreground",
  locked: "bg-payment-expired text-foreground",
  closed: "bg-payment-expired text-foreground",
}

export function ContractsPaymentBadge({
  variant,
  paidUntil
}: {
  variant: ContractStatusKey,
  paidUntil: string | null
}) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-3 py-1 sm:text-lg text-[16px] sm:leading-6 leading-[22px] font-medium",
        contractsPaymentBadgeStyles[variant as keyof typeof contractsPaymentBadgeStyles]
      )}
    >
      {variant === 'active' && paidUntil && (
        <span>{t('contracts.badge.paidUntil', { paidUntil: formatDateExtended(paidUntil) })}</span>
      )}
      {(variant === 'pending' || variant === 'pending_manual') && (
        <span>{t('contracts.badge.notPaid')}</span>
      )}
      {variant === 'locked' && (
        <span>{t('contracts.badge.locked')}</span>
      )}
      {variant === 'closed' && (
        <span>{t('contracts.badge.closed')}</span>
      )}
    </span>
  )
}
